import i18n from 'i18next';
import { appLogger } from 'app-lib/helpers/logging';
const logger = appLogger.create('generic helper');

/**
 * This function takes in the time and calculates the time since today.
 * @param fromTime
 * @returns {String}
 */
export function timeSinceToday(fromTime) {
    let durationNumber;
    if (!fromTime) {
        return '';
    }
    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;
    const msPerMonth = msPerDay * 30;
    const msPerYear = msPerDay * 365;

    const elapsed = (new Date()).getTime() - ((new Date(fromTime)).getTime());

    if (elapsed < msPerMinute) {
        durationNumber = (Math.round(elapsed / 1000));
        return durationNumber === 1 ? `${durationNumber} ${i18n.t('helpers.genericHelper.secondAgo')}` : `${durationNumber} ${i18n.t('helpers.genericHelper.secondsAgo')}`;
    } else if (elapsed < msPerHour) {
        durationNumber = (Math.round(elapsed / msPerMinute));
        return durationNumber === 1 ? `${durationNumber} ${i18n.t('helpers.genericHelper.minuteAgo')}` : `${durationNumber} ${i18n.t('helpers.genericHelper.minutesAgo')}`;
    } else if (elapsed < msPerDay) {
        durationNumber = (Math.round(elapsed / msPerHour));
        return durationNumber === 1 ? `${durationNumber} ${i18n.t('helpers.genericHelper.hourAgo')}` : `${durationNumber} ${i18n.t('helpers.genericHelper.hoursAgo')}`;
    } else if (elapsed < msPerMonth) {
        durationNumber = (Math.round(elapsed / msPerDay));
        return durationNumber === 1 ? `${durationNumber} ${i18n.t('helpers.genericHelper.dayAgo')}` : `${durationNumber} ${i18n.t('helpers.genericHelper.daysAgo')}`;
    } else if (elapsed < msPerYear) {
        durationNumber = (Math.round(elapsed / msPerMonth));
        return durationNumber === 1 ? `${durationNumber} ${i18n.t('helpers.genericHelper.monthAgo')}` : `${durationNumber} ${i18n.t('helpers.genericHelper.monthsAgo')}`;
    }
    durationNumber = (Math.round(elapsed / msPerYear));
    return durationNumber === 1 ? `${durationNumber} ${i18n.t('helpers.genericHelper.yearAgo')}` : `${durationNumber} ${i18n.t('helpers.genericHelper.yearsAgo')}`;
}

/**
 * This function takes in seconds and returns the time in HH:mm:ss string
 *
 * @param seconds
 * @returns {string}
 */
export function hmsTimeFormatFromSeconds(seconds) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = Math.floor(seconds % 3600 % 60);

    let timeString;

    if (h > 0) {
        timeString = (m < 10) ? `${h}:0` : `${h}:`;
    } else {
        timeString = '';
    }

    timeString = `${timeString}${m}:`;

    if (s < 10) { timeString = `${timeString}0`; }

    return `${timeString}${s}`;
}

export function findQueryValue(queryKey) {
    if (!queryKey) {
        logger.debug('Cannot find query value in URL with no query key');
        return null;
    }
    let searchStr = window.location.search;
    if (!searchStr) {
        logger.debug('No search string found in URL.');
        return null;
    }
    searchStr = searchStr.replace('?', '');
    const queries = searchStr.split('&');
    const query = queries.find((element) => {
        return element.includes(queryKey);
    });
    if (query) {
        const queryKeyValue = query.split('=');
        if (queryKeyValue.length < 2) {
            return null;
        }
        return queryKeyValue[1];
    }
    return null;
}

export function getChannelKeyFromUrl() {
    const href = window.location.href;
    const urlParts = href.split('/channel/');
    if (urlParts.length !== 2) {
        return null;
    }
    const params = urlParts[1].split('/');
    if (params.length < 1) {
        return null;
    }
    return params[0];
}

/**
 * Returns Url Query Parameters
 * @param queryParameterToCheck
 * @returns string queryValue or null
 */

export function getUrlQueryParameter(queryParameterToCheck) {
    const href = window.location.href;
    const reg = new RegExp(`[?&]${queryParameterToCheck}=([^&#]*)`, 'i');
    const queryValue = reg.exec(href);
    return queryValue ? queryValue[1] : null;
}

/**
 * converts url encoded query string to an object
 * @param queryString
 * @returns {Object}
 */
export function parseQueryString(queryString) {
    const result = {};
    if (queryString) {
        queryString.split('&').forEach((part) => {
            const item = part.split('=');
            result[item[0]] = decodeURIComponent(item[1]);
        });
        return result;
    }
    return null;
}

/**
 * converts 64 base encoded string to an object
 * @param urlQueryParam
 * @returns {Object}
 */
export function getWebinarAttendeeInfo(urlQueryParam) {
    let attendeeInfo = this.getUrlQueryParameter(urlQueryParam);
    if (attendeeInfo) {
        attendeeInfo = atob(attendeeInfo);
        attendeeInfo = this.parseQueryString(attendeeInfo);
        return attendeeInfo;
    }
    return null;
}

export function disableScrolling() {
    const body = document.getElementsByTagName('body');
    if (body.length === 1) {
        body[0].style.overflow = 'hidden';
    }
}

export function enableScrolling() {
    const body = document.getElementsByTagName('body');
    if (body.length === 1) {
        body[0].style.overflow = 'scroll';
    }
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/genericHelper.js